export default function FaqCard({text, freelancerType = false}) {
    return (
        <div className={`faq-card-item py-4 pr-2 border-r-2 duration-300 cursor-pointer ${freelancerType ? 'freelancer-type' : ''}`}>
            <p className="font-semibold text-justify leading-[171%] duration-300">{text}</p>
        </div>
    )
}
